<template>
  <div :id="'iitem_' + type.norm() + '_' + iitemid" :class="'iitem_' + type.norm() + '_' + iitemid"
    class="container iitem" v-if="
      single &&
      Object.keys(single).length > 0 &&
      (single.basics.published ||
        single.user == $store.state.auth.uid ||
        $store.state.app.user.includes($store.state.auth.uid) ||
        ($store.state.app.advanced.roles.admin &&
          $store.state.app.advanced.roles.admin.members &&
          $store.state.app.advanced.roles.admin.members.includes(
            $store.state.auth.uid
          )))
    ">
    <div :class="`special_delivery special_delivery_item_${type}`"
      :key="$store.state.counter + `special_delivery_item_${type}`"
      v-if="$store.state.iitem[type] && $store.state.iitem[type][iitemid]">
      <state v-if="typeof $store.state.iitem[type][iitemid] == 'object'" :statedata="$store.state.iitem[type][iitemid]"
        :parent="type + '.' + iitemid" />
      <icontent v-else :content="$store.state.iitem[type][iitemid]" />
    </div>
    <span :id="'iitem_meta_' + type.norm() + '_' + iitemid" :class="'iitem_meta_' + type.norm() + '_' + iitemid"
      class="flex xs-font wrap align-center between p8 iitem_meta">
      <user class="xs-font r8" :userid="single.user"></user>
      <itime v-if="single.created" class="update-text" :timestamp="single.events ? single.events.date : single.created">
      </itime>
      <a href v-if="single.user === $store.state.auth.uid || ($store.state.app.advanced.roles.admin && $store.state.app.advanced.roles.admin.members && $store.state.app.advanced.roles.admin.members.includes($store.state.auth.uid))" @click.prevent="
        $set($store.state.componentKeys, 'edit', Date.now());
      edit = !edit;
      " class="flex align-center update-text" type="button">
        <i class="fa fa-edit"></i>
        Edit
      </a>
    </span>
    <div v-if="$store.state.auth.uid === single.user || ($store.state.app.advanced.roles.admin && $store.state.app.advanced.roles.admin.members && $store.state.app.advanced.roles.admin.members.includes($store.state.auth.uid))" class="flex column fill">
      <div v-if="edit" class="indicate p8 m8">

        <span class="flex align-center between b8 xs-font">
          <b>EDIT {{ single.basics.title }}</b>
          <span class="flex align-center container p4">
            <i class="r8 fa fa-download" @click="
              $store.dispatch('export', {
                name: single.basics.title,
                type,
                data: single,
              })
              " />
            <rm :item="{ type, id: iitemid }" />
          </span>
        </span>

        <iform :id="'iform_' + type.norm()" :class="'container p4 iform_' + type.norm()" :is="'iform'"
          :key="'edit' + $store.state.componentKeys.edit" :prefill="single" :form-model="formModel" relative='true' />
        
        <!-- Components Section for Items -->
        <div class="container p4 b8 r4 mt8">
          <div class="flex align-center between b8">
            <label class="section-label">Widgets</label>
            <button class="p4 update-border" type="button" @click="show.pickComponents = !show.pickComponents">
              <i class="update-text fa fa-cubes p4"></i>
            </button>
          </div>
          
          <div v-if="show.pickComponents" class="post-section">
            <div class="flex wrap" v-for="(components, componentcategory) in $store.state.components"
              :key="'item-' + componentcategory">
              <div class="indicate-text border-bottom">{{ componentcategory }}</div>
              <div class="flex wrap align-center">
                <span v-for="(comp, compkey) in components" :key="compkey" @click="addComponentToItem(comp)">
                  <span class="p4"><i v-if="'displayinstancewidgets'.indexOf(componentcategory) >= 0"
                      class="fa-sm fa fa-plus"></i>{{ comp }}</span>
                </span>
              </div>
            </div>

            <!-- Component Management UI -->
            <div v-if="single.components && single.components.length > 0" class="mt4">
              <div v-for="(comp, cidx) in single.components" :key="comp.name + cidx"
                class="t8 container p8 indicate-border">
                <div class="flex align-center between xs-font">
                  <div>
                    <i @click="moveComponent(single.components, cidx, -1)" v-if="cidx > 0"
                      class="fa fa-arrow-up r4"></i>
                    <i @click="moveComponent(single.components, cidx, 1)"
                      v-if="cidx < single.components.length - 1" class="fa fa-arrow-down"></i>
                  </div>
                  <span @click="$set(show, 'editComp' + cidx, !show['editComp' + cidx])">
                    <b class="md-font align-center flex">
                      <i class="fa fa-box r4" />
                      {{ comp.name }}
                    </b>
                    <span class="update-text xs-font p4">
                      {{ getPropsSummary(comp.props) }}
                    </span>
                  </span>
                  <i class="fa fa-trash warn-text" @click="single.components.splice(cidx, 1)"></i>
                </div>
                <div v-if="show['editComp' + cidx]" class="p4">
                  <div class="flex column">
                    <!-- New Prop Editor -->
                    <div class="p4 b8 r4">
                      <label class="xs-font">Component Props</label>
                      <select v-model="comp._selectedProp" @change="onPropSelect(comp)" class="xs-input">
                        <option :value="null">-- Select a prop to edit --</option>
                        <option v-for="(prop, propName) in $cp[comp.name]" :key="propName" :value="propName">
                          {{ propName }}
                        </option>
                      </select>

                      <div v-if="comp._selectedProp" class="p4">
                        <iinput :label="comp._selectedProp" :type="getPropInputType(comp.name, comp._selectedProp)"
                          v-model="comp._propValue" />
                        <button class="p4 update" type="button" @click="saveProp(comp)">Save Prop</button>
                      </div>
                    </div>

                    <!-- Style Editor -->
                    <div class="p4 b8 r4 mt8">
                      <label class="xs-font">Styles (JSON)</label>
                      <textarea v-model="comp._stylesText" class="xs-input" placeholder="styles as JSON"></textarea>
                      <button class="p4" type="button" @click="saveComponentStyles(comp)">Save Styles</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="iitem_content p8 flex column">
      <div class="flexy iitem_heading">
        <h1 v-if="single.basics" class="align-center xl-font flexy p8 iitem_heading_title">
          {{ single.basics.title }}
        </h1>
        <span class="flex xs-font p4 wrap iitem_heading_tagcat">
          <router-link class="r8 indicate-text iitem_heading_tagcat_cat" :to="'/list/' + single.type">
            <i :class="$store.state.icons[type]" class="r4 iitem_heading_tagcat_cat_icon"></i>
            <span class="iitem_heading_tagcat_cat_name">{{
              single.type.toUpperCase()
              }}</span>
          </router-link>
          <div v-if="single.basics && single.basics.tags">
            <div :style="tagKey + 1 !== single.basics.tags.length
                ? ''
                : 'margin-right: 0'
              " class="r8 iitem_heading_tagcat_tag" :key="tagKey" v-for="(tag, tagKey) in single.basics.tags">
              <router-link :to="`/tags/${single.type}/${tag}`" class="indicate-text iitem_heading_tagcat_tag_link">
                <i class="fas fa-hashtag fa-xs iitem_heading_tagcat_tag_icon"></i>
                <span class="iitem_heading_tagcat_tag_name">{{ tag }}</span>
              </router-link>
            </div>
          </div>
        </span>
      </div>
      <div class="b16 flexy">
        <img v-if="single.basics && single.basics.image" class="flexy iitem_content_image"
          :src="single.basics.image || $store.state.app.basics.logo"
          :alt="single.basics.tags + ' ' + single.basics.title" />
        <div class="
            flexy
            flex
            wrap
            column
            align-center
            b16
            iitem_content_components
          ">
          <buy :key="'buy component' + ($store.state.counts.buy || 0)" :item="single" v-if="
            $store.state.app.basics.modules.indexOf('purchases') &&
            single.purchases
          " class="flexx p16 iitem_content_components_buy"></buy>

          <attend :key="'event' + $store.state.componentKeys.events" class="flexx p16 iitem_content_components_attend"
            v-if="
              $store.state.app.basics.modules.indexOf('events') && single.events
            " :eType="type" :eId="iitemid"></attend>
          <apply :key="'job' + $store.state.componentKeys.jobs" class="flexx p16 iitem_content_components_apply" v-if="
            $store.state.app.basics.modules.indexOf('jobs') && single.jobs
          " :jType="type" :jId="iitemid"></apply>
          <maps v-if="
            $store.state.app.basics.modules.indexOf('maps') > -1 && single.map
          " :description="single.basics ? single.basics.description || '' : ''"
            :title="single.basics ? single.basics.title || '' : ''" :address="single.map.address" :type="type"
            :id="iitemid" class="iitem_content_components_map" />
          <widget
            v-if="single.basics && (single.basics.description || (single.components && single.components.length > 0) || (single.media && single.media.length > 0) || (single.composition && single.composition.rows && single.composition.rows.length > 0))"
            class="flexz md-font wrap iitem_content_components_description"
            :text="single.basics ? (single.basics.description || '') : ''"
            :components="single.components || []"
            :media="single.media || []"
            :links="single.links || []"
            :embeds="single.embeds || ''"
            :userId="single.user || ''"
            :bypass-truncation="single.basics && single.basics.bypassTruncation || false"
            :editable="single.user === $store.state.auth.uid || ($store.state.app.advanced.roles.admin && $store.state.app.advanced.roles.admin.members && $store.state.app.advanced.roles.admin.members.includes($store.state.auth.uid))"
            :composition="single.composition"
            @composition-updated="onCompositionUpdated"
          />
          <iiframe v-if="single.links && single.links.homepage" :appsrc="single.links && single.links.homepage"
            class="fill iitem_content_components_iiframe"></iiframe>
        </div>
      </div>
      <state v-if="$store.state.dev" class="container p4 indicate-border" tree="true" :statedata="itemdata" />
    </div>
    <div :class="`${$store.state.device.mobile ? 'p4' : 'p16'}`" class="p8 flex align-center fit iitem_footer" v-if="
      $store.state.modules.indexOf('profiles') > -1 &&
      $store.state.items[type] &&
      single.user
    ">
      <b class="r8 xs-font">Created by</b>
      <user :userid="single.user"></user>
    </div>
  </div>
  <div v-else-if="loading">Loading content...</div>
  <div v-else class="label warn p32 m16">
    <h5 class="flex align-center b8">
      <i class="fas fa-exclamation-triangle r4" />
      {{ (single.basics && single.basics.title) || "Item" }} is unavialble.
    </h5>
    <code>If you think this is an error, check yourself before you wreck yourself,
      or somehow contact the app admin. Good luck!</code>
  </div>
</template>
<style>
.iitem {
  flex: 1.618 1 100%;
}

.iitem_heading_title,
.iitem_content_components_buy,
.iitem_content_components_attend,
.iitem_content_components_apply,
.iitem_content_components_map,
.iitem_content_property_object_property_text {
  min-width: 270px;
}

.iitem_content_image {
  object-fit: contain;
  min-width: 240px;
  width: 90%;
  max-width: 480px;
  float: left;
}

.iitem_content_components {
  min-width: 240px;
  height: fit-content;
  max-width: 480px;
}

/* .iitem_content_components_map {
  max-height: 420px;
} */
.iitem_content_property {
  min-width: 270px;
  max-width: 540px;
}

.iitem_content_components_description {
  min-width: 270px;
  max-width: 100%;
  height: fit-content;
}

.iitem_heading_tagcat {
  max-height: 80px;
  overflow: scroll;
}
</style>
<script>
export default {
  computed: {
    allowed() {
      let allowed = {};
      let model = JSON.parse(
        JSON.stringify(this.$store.state.app.forms[this.type])
      );
      model.forms.map((x) => {
        allowed[x.name] = allowed[x.name] || [];
        x.inputs.map((y) => {
          y.display.single ? allowed[x.name].push(y.label) : null;
        });
      });
      return allowed;
    },
    formModel() {
      if (!this.$store.state.app.forms[this.type]) return;
      let model = JSON.parse(
        JSON.stringify(this.$store.state.app.forms[this.type])
      );
      model.forms.map((x) => {
        x.inputs = x.inputs.filter((y) => y.display.form);
        return x;
      });
      return model;
    },
    itemdata() {
      let itemdata = {};
      this.model.forms.map((x) => {
        x.name !== "basics"
          ? (itemdata[x.name] = itemdata[x.name] || {})
          : null;
        x.inputs.map((y) => {
          !y.display ? this.$set(y, "display", { single: true }) : null;
          !itemdata[x.name] ? this.$set(itemdata, x.name, {}) : null;
          !this.single[x.name] ? this.$set(this.single, x.name, {}) : null;
          x.name !== "basics" && y.display.single
            ? (itemdata[x.name][y.label] = this.single[x.name][y.label])
            : null;
        });
      });
      return itemdata;
    },
    original() {
      return JSON.parse(JSON.stringify(this.single))
    }
  },
  data() {
    return {
      display: false,
      edit: false,
      loading: true,
      qty: 1,
      prsprtyLink: "",
      showError: false,
      secret: {},
      show: {
        confirm: [],
        pickComponents: false,
      },
      model: JSON.parse(JSON.stringify(this.$store.state.app.forms[this.type])),
      single: {},
      prohibitedProps: [
        "events",
        "id",
        "image",
        "jobs",
        "map",
        "purchases",
        "created",
        "title",
        "type",
        "user",
        "basics",
        "ownedBy",
      ],
      };
    },
    methods: {
      addComponentToItem(name) {
        if (!this.single.components) {
          this.$set(this.single, 'components', []);
        }
        const newComp = { name: name, props: {}, styles: {}, _selectedProp: null, _propValue: null };
        this.single.components.push(newComp);
      },
      moveComponent(components, index, direction) {
        const newIndex = index + direction;
        if (newIndex < 0 || newIndex >= components.length) return;
        const [item] = components.splice(index, 1);
        components.splice(newIndex, 0, item);
      },
      getPropsSummary(props) {
        if (!props || Object.keys(props).length === 0) return '';
        return Object.entries(props).map(([key, value]) => {
          if (typeof value === 'string' && value.length > 15) {
            return `${key}: "${value.substring(0, 12)}..."`;
          }
          if (typeof value === 'object' && value !== null) {
            return `${key}: {...}`
          }
          return `${key}: ${value}`;
        }).join(', ');
      },
      getPropInputType(compName, propName) {
        const prop = this.$cp[compName]?.[propName];
        if (!prop) return 'text';
        const type = prop.type;
        if (type === String) return 'text';
        if (type === Boolean) return 'checkbox';
        if (type === Number) return 'number';
        if (type === Object || type === Array) return 'textarea';
        return 'text';
      },
      onPropSelect(comp) {
        if (comp._selectedProp) {
          comp._propValue = comp.props[comp._selectedProp] || '';
        }
      },
      saveProp(comp) {
        if (comp._selectedProp && comp._propValue !== undefined) {
          this.$set(comp.props, comp._selectedProp, comp._propValue);
          comp._selectedProp = null;
          comp._propValue = null;
        }
      },
      saveComponentStyles(comp) {
        try {
          comp.styles = JSON.parse(comp._stylesText || '{}');
        } catch (e) {
          console.error('Invalid JSON for styles:', e);
        }
      },
      onCompositionUpdated(compositionData) {
        if (!this.single.composition) {
          this.$set(this.single, 'composition', {});
        }
        this.$set(this.single, 'composition', compositionData);
        // Trigger update
        this.$store.dispatch('update', {
          type: this.type,
          id: this.iitemid,
          data: { composition: compositionData }
        });
      },
    },
    metaInfo() {
    if (
      this.$store.state.items[this.type] &&
      this.$store.state.items[this.type][this.iitemid] &&
      this.$store.state.items[this.type][this.iitemid].basics
    ) {
      return {
        title: this.$store.state.items[this.type][this.iitemid].basics.title,
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.$store.state.app.basics.mission || "XMBL app",
          },
        ],
      };
    } else {
      return {
        title: this.$store.state.app.basics["app name"],
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.$store.state.app.basics.mission || "XMBL app",
          },
        ],
      };
    }
  },
  mounted() {
    let itemconfig = this.$store.state.app.basics.items.filter(
      (x) => x.name === this.type
    )[0];
    itemconfig &&
      itemconfig.hooks &&
      itemconfig.hooks.item &&
      itemconfig.hooks.item.fun &&
      this.$store.dispatch("run", {
        props: { id: this.iitemid, type: this.type },
        from: "item " + this.type + ": " + this.iitemid,
        if: itemconfig.hooks.list.if || [],
        fun: this.$store.state.app.advanced.functions[
          itemconfig.hooks.item.fun.name
        ],
        payload: itemconfig.hooks.item.payload || {},
      });
    // TODO save to localstorage and skip db trip
    this.$store
      .dispatch("query", {
        type: "item",
        collection: this.type || this.$route.params.type,
        id: this.iitemid || this.$route.params.iitemid,
      })
      .then((ret) => {
        this.$store.state.counts.edit = this.$store.state.counts.edit + 1;
        ret
          ? this.$set(this, "single", ret)
          : null;
        this.loading = false;
      });
    // TODO test this captures the relavent ids and
    // then remove hardcode for beyond
  },
  name: "item",
  props: { iitemid: { type: String }, type: { type: String } }
};
</script>
